import React from 'react';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import properties from '../../../modules/ajio-util/properties';
import { readCookieAtNode, readCookie } from '../../../utils/Cookie.js';
import isNode from '../../../modules/ajio-util/isNode';

const ACCOUNT_TEXT_FORMAT = 'account';

const fallbackBottomNavList = [
  {
    appMedia: {
      url: '',
      classes: 'ic-app-logo img-style active'
    },
    appMedia2: {
      url: '',
      classes: 'ic-app-logo img-text-color'
    },
    nodeurlLink: '/shop/men',
    name: 'Home',
    title: 'Home',
    uid: 'Home',
    position: 1,
    newFlag: false
  },
  {
    appMedia: {
      url: '',
      classes: 'ic-store img-style active'
    },
    appMedia2: {
      url: '',
      classes: 'ic-store img-text-color'
    },
    nodeurlLink: '/shop/stores',
    name: 'Stores',
    title: 'Stores',
    uid: 'Stores',
    position: 2,
    newFlag: false
  },
  {
    appMedia: {
      url: '',
      classes: 'ic-accounts img-style active'
    },
    appMedia2: {
      url: '',
      classes: 'ic-accounts img-text-color'
    },
    nodeurlLink: '/my-account',
    name: 'Account',
    title: 'Account',
    uid: 'Account',
    position: 3,
    newFlag: false
  },
  {
    appMedia: {
      url: '',
      classes: 'ic-closet img-style active'
    },
    appMedia2: {
      url: '',
      classes: 'ic-closet img-text-color'
    },
    nodeurlLink: '/wishlist',
    name: 'Closet',
    title: 'Closet',
    uid: 'Closet',
    position: 4,
    newFlag: false
  },
  {
    appMedia: {
      url: '',
      classes: 'ic-cart img-style active'
    },
    appMedia2: {
      url: '',
      classes: 'ic-cart img-text-color'
    },
    nodeurlLink: '/cart',
    name: 'Bag',
    title: 'Bag',
    uid: 'Bag',
    position: 5,
    newFlag: false
  }
];

const isStore = requestedUrl => {
  return isNode()
    ? _includes(requestedUrl, 'stores')
    : _includes(_get(window, 'location.pathname', ''), 'stores');
};

const getMyAccountUrl = (parentUrl, navUrl, reqObjectForStickyFooter) => {
  const cookieStatus = isNode() ? readCookieAtNode(reqObjectForStickyFooter, 'U') : readCookie('U');
  if (cookieStatus === null || cookieStatus === 'anonymous') {
    return `${parentUrl}/login?referrer=/my-account/`;
  }
  if (navUrl === '/my-account') {
    return `${parentUrl}${navUrl}/`;
  }
  return `${parentUrl}${navUrl}`;
};

const getNavUrl = (navText, navUrl, reqObjectForStickyFooter) => {
  const text = navText.toLowerCase().trim();
  const parentUrl = properties.getProperty('parentUrl');
  return text === ACCOUNT_TEXT_FORMAT
    ? getMyAccountUrl(parentUrl, navUrl, reqObjectForStickyFooter)
    : `${parentUrl}${navUrl}`;
};

const fallbackIconComponent = classes => <span className={classes} />;

const apiIconComponent = (classes, url) => (
  <img className={`${classes} sticky-nav-icon`} src={url} />
);

const renderNavIconComponent = (stickyFooterFallbackStatus, item, activeStatus) => {
  const { appMedia = {}, appMedia2 = {} } = item;
  const { classes = '', URL = '' } = activeStatus ? appMedia : appMedia2;
  return stickyFooterFallbackStatus
    ? fallbackIconComponent(classes)
    : apiIconComponent(classes, URL);
};

const getActiveStatus = (hasStoreRoute, title, nodeurlLink) => {
  const currentNavNodeUrl = nodeurlLink.toLowerCase();
  if (hasStoreRoute === true && currentNavNodeUrl.includes('store') === true) {
    return true;
  } else if (hasStoreRoute === false && title.toLowerCase().includes('home') === true) {
    return true;
  }
  return false;
};

const renderBottomNavItems = props => {
  const {
    stickyFooterFallbackStatus = false,
    requestedUrl = '',
    reqObjectForStickyFooter = {}
  } = props;
  let { bottomNavList = [] } = props;
  const isRequestUrlHasStoresRoute = isStore(requestedUrl);

  bottomNavList = stickyFooterFallbackStatus ? fallbackBottomNavList : bottomNavList;
  return bottomNavList.map(item => {
    const { title = '', nodeurlLink = '' } = item;
    const activeStatus = getActiveStatus(isRequestUrlHasStoresRoute, title, nodeurlLink);
    const titleClass = activeStatus ? 'img-text-color active' : 'img-text-color';
    const activeBarClass = activeStatus ? 'active-bar' : '';
    return (
      <div key={title} className="ftr-text-val">
        <a href={getNavUrl(title, nodeurlLink, reqObjectForStickyFooter)}>
          {renderNavIconComponent(stickyFooterFallbackStatus, item, activeStatus)}
          <span className={titleClass}>{title}</span>
        </a>
        <div className={activeBarClass} />
      </div>
    );
  });
};

const StickyFooter = props => {
  return (
    <div className="sticky-ftr">
      <div className="ftr-box">{renderBottomNavItems(props)}</div>
    </div>
  );
};

export default StickyFooter;
